module.exports = __webpack_public_path__ + "img/technology_icon_08.89765509.png";